
export default function Product() {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center space-y-4 mb-20">
          <h2 className="text-5xl lg:text-6xl font-light text-gray-900 tracking-tight">
            Our Product
          </h2>
          <div className="h-1 w-24 bg-blue-500 mx-auto"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center" data-product-shop>
          {/* Product Image */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-100 to-gray-100 rounded-3xl blur-3xl opacity-30"></div>
            <div className="relative bg-gradient-to-br from-gray-50 to-blue-50 rounded-3xl p-12 shadow-2xl">
              <img
                src="https://static.readdy.ai/image/c35fb388e939118942ecbf693c1f9da9/f81ef94890de2cd11852d73b3b1cef87.png"
                alt="Heritage Water Resealable Aluminum Bottle-Can 500ml"
                className="w-full h-auto object-contain drop-shadow-2xl"
              />
            </div>
          </div>

          {/* Product Details */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h3 className="text-4xl lg:text-5xl font-light text-gray-900">
                Resealable Aluminum<br />Bottle-Can
              </h3>
              <p className="text-2xl text-blue-600 font-medium">500ml</p>
            </div>

            <div className="h-px bg-gray-200"></div>

            <ul className="space-y-6">
              <li className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-50 rounded-full flex-shrink-0">
                  <i className="ri-vip-crown-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-medium text-gray-900 mb-1">Premium Mineral Water</h4>
                  <p className="text-gray-600 font-light">최고급 천연 미네랄워터</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-50 rounded-full flex-shrink-0">
                  <i className="ri-earth-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-medium text-gray-900 mb-1">Sourced from UNESCO Biosphere</h4>
                  <p className="text-gray-600 font-light">유네스코 생물권보전지역에서 채수</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-50 rounded-full flex-shrink-0">
                  <i className="ri-close-circle-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-medium text-gray-900 mb-1">No Plastic, No Microplastics</h4>
                  <p className="text-gray-600 font-light">플라스틱 제로, 미세플라스틱 제로</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-50 rounded-full flex-shrink-0">
                  <i className="ri-recycle-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-medium text-gray-900 mb-1">100% Infinitely Recyclable Aluminum</h4>
                  <p className="text-gray-600 font-light">무한 재활용 가능한 알루미늄</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-50 rounded-full flex-shrink-0">
                  <i className="ri-palette-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-medium text-gray-900 mb-1">Minimalist Modern Design</h4>
                  <p className="text-gray-600 font-light">미니멀하고 모던한 디자인</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
